import { requestMagicLink } from "../lib/auth.js";

export function mountLogin(root) {
  root.innerHTML = `
    <div class="login-screen" role="main" aria-label="Login do Pixel Dashboard">
      <img class="login-logo" src="/branding/logo.svg" alt="SyntheticStudio.AI" width="96" height="96" />
      <h1 class="pixel-heading login-title">Pixel Dashboard</h1>
      <form class="login-form" novalidate>
        <label for="login-email" class="visually-hidden">Email</label>
        <input
          id="login-email"
          name="email"
          type="email"
          placeholder="seu-email@syntheticstudio.com.br"
          autocomplete="email"
          required
        />
        <button type="submit">Enviar magic link</button>
      </form>
      <p class="login-status" role="status" aria-live="polite"></p>
    </div>
  `;

  const form = root.querySelector(".login-form");
  const status = root.querySelector(".login-status");
  const emailInput = root.querySelector("#login-email");
  const submitButton = form.querySelector("button");

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const email = emailInput.value.trim();
    if (!email) return;

    submitButton.disabled = true;
    status.textContent = "Enviando link...";
    status.classList.remove("login-status--error");

    try {
      await requestMagicLink(email);
      status.textContent = `Link enviado para ${email}. Confira sua caixa de entrada.`;
    } catch (error) {
      status.textContent = error instanceof Error ? error.message : "Falha ao enviar o link.";
      status.classList.add("login-status--error");
    } finally {
      submitButton.disabled = false;
    }
  });

  return () => {
    root.innerHTML = "";
  };
}
